(function (ws) {
    'use strict';

    ws.views.duplicateResellerCheck = ws.views.modal.extend({
        /**
         * Extend default events
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .qut-sap-block-msg-continue': 'continueSubmission'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            this.eventAgg.on('renderDuplicateResellerOverlay', this.renderDuplicateResellerOverlay, this);
            ws.views.modal.prototype.initialize.call(this);
        },

        /**
         * Render Modal
         * @param {string} target
         */
        renderDuplicateResellerOverlay: function(target) {
            this.eventAgg.trigger(this.$el.attr('id'));
        },

        /**
         * This method will update EstimateFreight
         */
        continueSubmission: function (e) {
            ws.views.modal.prototype.closeModal.call(this);
            this.eventAgg.trigger('continueSubmission', e, true);
        }
    });
})(westcon);
